import { Check } from '@phosphor-icons/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface StepIndicatorProps {
    currentStep: 1 | 2;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
    currentStep,
}) => {
    const { t } = useTranslation();
    return (
        <div className="flex items-center justify-center gap-2">
            {/* Step 1 */}
            <div className="flex items-center gap-2">
                <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 ${currentStep === 2
                        ? 'bg-secondary-600 text-white'
                        : 'bg-primary-600 text-white'
                        }`}
                >
                    {currentStep === 2 ? <Check size={16} weight="bold" /> : '1'}
                </div>
                <div className="flex flex-col">
                    <span
                        className={`text-sm font-semibold ${currentStep === 2
                            ? 'text-secondary-600 dark:text-secondary-400'
                            : 'text-primary-600 dark:text-primary-400'
                            }`}
                    >
                        {t('configurations.integrations.steps.authenticate')}
                    </span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">{t('configurations.integrations.steps.connectSources')}</span>
                </div>
            </div>

            {/* Connector Line */}
            <div
                className={`w-16 h-0.5 mx-2 transition-all duration-300 ${currentStep === 2 ? 'bg-secondary-600 dark:bg-secondary-400' : 'bg-gray-300 dark:bg-neutral-600'
                    }`}
            />

            {/* Step 2 */}
            <div className="flex items-center gap-2">
                <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 ${currentStep === 2
                        ? 'bg-primary-600 text-white'
                        : 'bg-gray-200 dark:bg-neutral-700 text-gray-600 dark:text-gray-400'
                        }`}
                >
                    2
                </div>
                <div className="flex flex-col">
                    <span
                        className={`text-sm font-semibold ${currentStep === 2 ? 'text-primary-600 dark:text-primary-400' : 'text-gray-500 dark:text-gray-400'
                            }`}
                    >
                        {t('configurations.integrations.steps.pairAndFinalize')}
                    </span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">{t('configurations.integrations.steps.reviewAndConfirm')}</span>
                </div>
            </div>
        </div>
    );
};

export default StepIndicator;
